import { createContext, useEffect, useState } from 'react';

export const MainContext = createContext({});

const networks = {
  1: { id: 1, name: 'Mainnet', etherscan: '' },
  3: { id: 3, name: 'Ropsten', etherscan: 'ropsten' }
};

export const MainContextProvider = ({ children }) => {
  const [currentNetwork, setCurrentNetwork] = useState(1);
  const [networkData, setNetworkData] = useState(networks[currentNetwork]);
  const [address, setAddress] = useState('');

  useEffect(() => {
    setNetworkData(networks[currentNetwork]);
  }, [currentNetwork])

  return (
    <MainContext.Provider
      value={{
        networkData,
        currentNetwork,
        setCurrentNetwork,
        address,
        setAddress
      }}>
      {children}
    </MainContext.Provider>
  );
};

export default MainContextProvider;
